import { render, staticRenderFns } from "./QuoteHistory.vue?vue&type=template&id=3bf5e994&"
import script from "./QuoteHistory.vue?vue&type=script&lang=js&"
export * from "./QuoteHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports